export const API_URL = 'https://forkify-api.herokuapp.com/api/v2/recipes/';
export const TIMEOUT_SEC = 10;
export const RES_PER_PAGE = 10;
export const KEY = '6cbe99b4-b83b-4ea1-a034-a2183abd8420';
export const MODAL_CLOSE_SEC = 2.5;
